import React, { useEffect, useState } from "react";
import {
  Modal,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { CustomSelect } from "../../CustomControls/CustomSelect";
import {
  createRegulatoryGroup,
  getCreateRegulatoryGroup,
} from "../../../api/clinicalTrial";
import { Spinner } from "../../Utils/Loaders";
import { HandleApiError } from "../../Notifications/APIErrorHandler";

export const ModalCreateGroup = ({ show, onClose, onAccept }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    title: "",
    categories: [],
  });

  const [loading, setLoading] = useState(true);
  const [categoryOptions, setCategoryOptions] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getCreateRegulatoryGroup();

        if (result.status === 200) {
          const categories = result.data.attachmentsCategories.map((x) => ({
            id: x.id,
            name: x.name,
          }));

          setCategoryOptions(categories);
        }
      } catch (error) {
        HandleApiError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const data = {
        name: formData.title,
        attachmentsCategories: formData.categories.map((x) => x.id),
      };
      await createRegulatoryGroup(data);
      onAccept();
    } catch (error) {
      HandleApiError(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      keyboard={false}
      dialogClassName="rounded-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {t("regulatorySubmissions.groups.modalCreate.title")}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {loading && <Spinner />}
        {!loading && (
          <>
            <FormGroup controlId="formTitle">
              <ControlLabel>
                {t("regulatorySubmissions.groups.modalCreate.groupName")}{" "}
                <span className="text-danger">*</span>
              </ControlLabel>
              <FormControl
                type="text"
                placeholder="Título"
                value={formData.title}
                onChange={(e) => handleChange("title", e.target.value)}
              />
            </FormGroup>
            <FormGroup controlId="formCategories">
              <ControlLabel>
                {t("regulatorySubmissions.groups.modalCreate.selectCategories")}{" "}
                <span className="text-danger">*</span>
              </ControlLabel>
              <CustomSelect
                value={formData.categories}
                name="categories"
                placeholder={t("commons.select")}
                onChange={handleChange}
                isMulti={true}
                isClearable={true}
                closeMenuOnSelect={false}
                options={categoryOptions}
                getOptionLabel={(option) => option.name}
                getOptionValue={(option) => option.id}
              />
            </FormGroup>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={onClose}>
          {t("regulatorySubmissions.groups.modalCreate.cancelLabel")}
        </Button>
        <Button
          variant="btn btn-primary"
          disabled={!formData.title || !formData.categories.length}
          onClick={handleSubmit}
        >
          {t("regulatorySubmissions.groups.modalCreate.acceptLabel")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
